"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'onboarding.delete.confirm.title': 'Usuń Onboarding',
    'onboarding.delete.confirm.message': 'Czy na pewno chcesz usunąć tę sesję onboardingu?',
};
